module.exports = __webpack_public_path__ + "img/ql-icon.c8b18560.png";